<template>
  <div class="status-flag">
    <span class="status-flag__left"></span>
    <span class="status-flag__right">
      <slot>{{ content }}</slot>
    </span>
  </div>
</template>

<script>
export default {
  name: 'BaseStatusFlag',

  props: {
    content: String
  }
}
</script>

<style lang="scss" scoped>
  .status-flag {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    &__left {
      position: relative;
      float: left;
      width: 20px;
      height: 100%;
      background-color: $--color-primary;
      transform: skewX(-30deg);
      &::before,
      &::after {
        content: '';
        position: absolute;
        left: 2px;
        width: 2px;
        height: 100%;
        background-color: #fff;
      }
      &::after {
        left: 6px;
      }
    }
    &__right {
      display: block;
      margin-left: 10px;
      padding: 0 20px;
      background-color: $--color-primary;
      color: $--color-white;
    }
  }
</style>
